import { Usuario } from 'user/models/Usuario';
import { EmailError } from './emailErrors';
import { FetchDataError, FetcherService, useFetcherService } from 'shared/http';
import { Funcionalidades } from 'user/models/Funcionalidades';
import { UserRequest } from 'user/models/UserRequest';

export class UserService extends FetcherService {
  async getAuthenticatedUserData() {
    return this.get<Usuario>('usuarios/authenticated').then((r) => r.body);
  }

  async confirmEmail(tokenEmail: string) {
    return this.post<void>('usuarios/mail/confirmation', { tokenEmail }, false, true);
  }

  async registerEmail(mail: string) {
    return this.post<void>('usuarios/mail/register', { mail }).catch(
      (e: FetchDataError) => {
        throw new EmailError(e.apiError, e.statusCode);
      },
    );
  }

  async getUsers(filter?: string) {
    const url = filter ? `usuarios?filter=${encodeURIComponent(filter)}` : 'usuarios';
    return this.get<Usuario[]>(url);
  }

  async getUser(id: string) {
    return this.get<Usuario>(`usuarios/${id}`).then((r) => r.body);
  }

  async findFuncionalidades(tipoUsuario?: string): Promise<Funcionalidades[]> {
    return this.get<Funcionalidades[]>(
      `usuarios/funcionalidades?tipoUsuario=${tipoUsuario}`,
    ).then((r) => r.body);
  }

  async saveUser(id: string, data: UserRequest) {
    if (id) {
      return this.updateUser(id, data);
    }
    return this.createUser(data);
  }

  async createUser(data: UserRequest) {
    return this.post<void>('usuarios', data);
  }

  async updateUser(id: string, data: UserRequest) {
    return this.put<void>(`usuarios/${id}`, data);
  }

  async deleteUser(user: Usuario) {
    return this.del<void>(`usuarios/${user.id}`);
  }
}

const userService = new UserService();

export function useUserService() {
  const { registerFetcherService } = useFetcherService();

  registerFetcherService(userService);

  return userService;
}
